module.exports = __webpack_public_path__ + "img/ta-ny-rightTitleBg01.86f4ed85.png";